import { Security, People } from '@mui/icons-material';
import type { BaseRoute } from '@core/routing/helper-components/Routes';
import { Module } from './types';
import UsersList from './pages/UsersList';
import RolesList from './pages/RolesList';
import Profile from './pages/Profile';

export const adminRoutes: BaseRoute[] = [
  {
    path: '/admin/users',
    component: UsersList,
    title: 'Users',
    showInSidebar: false,
    icon: <People />,
    sidebarText: 'Users',
    module: Module.USER,
    requiresView: true,
  },
  {
    path: '/admin/roles',
    component: RolesList,
    title: 'Roles',
    showInSidebar: false,
    icon: <Security />,
    sidebarText: 'Roles',
    module: Module.USER,
    requiresView: true,
  },
  {
    path: '/profile',
    component: Profile,
    title: 'Profile',
    showInSidebar: false,
    isPublic: true, // Profile is accessible to all authenticated users
  },
];
